import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import uploadImage from '../../assets/img/uploadImage.png'
import { Accept } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { translate } from '../../utils/language';
import systemSlice from '../../redux/systemSlice';

const UrlImageDropZone: any = (props: { isError: string | boolean, specialDesc?: any, onFileUpload: any, styleSpecial?: any, boxWidth?: any, boxHeight?: any, resolution?: any, text: string, uploadType?: any, accept?: Accept, uploadRef?: any, imageText?: string, required?: boolean, enableVideoUpload?: boolean, enableFormats?: boolean }) => {
    const [selectedImage, setSelectedImage] = useState('');
    const dispatch = useDispatch()
    const { onFileUpload, text, isError, accept, uploadRef, enableVideoUpload } = props;

    const onDrop = useCallback((acceptedFiles: File[]) => {
        // Do something with the uploaded files
        onFileUpload(acceptedFiles);
        setSelectedImage(URL.createObjectURL(acceptedFiles[0]));
    }, [onFileUpload]);

    const acceptedTypes = accept || {
        'image/png': ['.png'],
        'image/jpg': ['.jpg'],
        'image/gif': ['.gif'],
        'image/webp': ['.webp'],
        ...(enableVideoUpload ? {
            'video/mp4': ['.mp4']
        } : {})
    }
    const { getRootProps, getInputProps } = useDropzone({
        onDropAccepted: onDrop,
        accept: acceptedTypes,
        onDropRejected: (e) => {
            e?.map(file => {
                const errors = file.errors
                errors.map(error => {
                    console.log(error)
                    dispatch(systemSlice.actions.setToastError({ summary: translate(error.code), detail: `${translate("acceptedFileTypes")}: ${Object.values(acceptedTypes)?.map(type => type[0])?.join(", ")}` }))
                })
            })
        }
    });
    let displayText;

    if (props.uploadType === undefined || props.uploadType === 1) {
        displayText = <div style={props.styleSpecial} className={`w-full h-full flex items-center justify-center flex-col w-[${props.boxWidth}px] h-[${props.boxHeight}px] rounded-[10px]  ${isError ? "" : "bg-[#F3F2FC] border-[#7059EF] border-2 border-dashed"}`}>
            <img className='w-[30px] self-center' src={uploadImage} />
            <span className='text-[#7059EF] text-[15px] font-medium'>{props.imageText}</span>
            <p className={`${isError ? "text-red-500 text-[14px] px-2 py-2" : ""} `}>{isError || text} </p>

        </div>;
    } else if (props.uploadType === 2) {
        displayText = (
            <div style={props.styleSpecial} className={`w-full h-full flex items-center justify-center w-[${props.boxWidth}px] h-[${props.boxHeight}px] rounded-[10px]  ${isError ? "" : "bg-[#F3F2FC] border-[#7059EF] border-2 border-dashed"} flex flex-col gap-[5px]`}>
                <img className='w-[30px] self-center' src={uploadImage} />

                <span className='text-[#7059EF] text-[15px] font-medium'>{props.resolution}</span>

                <span className='text-[#7059EF] text-[15px] font-medium'>{props.imageText}</span>
                <p className={`${isError ? "text-red-500 text-[14px] px-2 py-2" : ""} `}>{isError || text} </p>

            </div>
        );
    }

    return (
        <div {...getRootProps()} className='m-auto w-full h-full flex items-center justify-center shrink-0 ' >
            <input  {...getInputProps()} />
            <div className='flex w-full h-full'>
                <div className="self-center w-[100%] h-[100%] overflow-hidden relative m-auto">
                    <div className="text-center flex flex-col w-full h-full items-center justify-center">

                        {displayText}



                    </div>
                </div>

            </div>



        </div>
    );
};
export default UrlImageDropZone;